import CivilianTrainingArea from "@/types/CivilianTrainingArea";
import MilitaryDiscipline from "@/types/MilitaryDiscipline";
import NetworkLite from "@/types/NetworkLite";
import TrainingInstitutionLite from "@/types/TrainingInstitutionLite";
import {CourseStatus} from "@/types/CourseStatus";
import Topic from "@/types/Topic";
import {TrainingAudience} from "@/types/TrainingAudience";
import {CourseType} from "@/types/CourseType";

export class CourseLite {
    
    id!: number;
    title!: string;
    courseTypeName!: CourseType;
    status!: CourseStatus;
    dateFrom!: Date;
    dateTo!: Date;
    deadline!: Date;
    network!: NetworkLite;
    provider!: TrainingInstitutionLite;
    venueCity!: string;
    venueCountry!: string;

    topics: Topic[] = [];
    euCivilianTrainingAreas: CivilianTrainingArea[] = [];
    militaryDisciplines: MilitaryDiscipline[] = [];
    otherTrainingInstitutions: TrainingInstitutionLite[] = [];
    trainingAudiences: TrainingAudience[] = [];


    public static fromResponse(data: any): CourseLite {

        const result: CourseLite = new CourseLite();

        if (data.id != undefined) {
            result.id = data.id;
        }

        if (data.title != undefined) {
            result.title = data.title;
        }

        if (data.courseTypeName != undefined) {
            result.courseTypeName = CourseType[data.courseTypeName as keyof typeof CourseType];
        }

        if (data.status != undefined) {
            result.status = CourseStatus[data.status as keyof typeof CourseStatus];
        }

        if (data.dateFrom != undefined) {
            result.dateFrom = new Date(data.dateFrom);
        }

        if (data.dateTo != undefined) {
            result.dateTo = new Date(data.dateTo);
        }

        if (data.deadline != undefined) {
            result.deadline = new Date(data.deadline);
        }

        if (data.network != undefined) {
            result.network = NetworkLite.fromResponse(data.network);
        }

        if (data.provider != undefined) {
            result.provider = TrainingInstitutionLite.fromResponse(data.provider);
        }

        if (data.venueCity != undefined) {
            result.venueCity = data.venueCity;
        }

        if (data.venueCountry != undefined) {
            result.venueCountry = data.venueCountry?.name;
        }

        if (data.topics != undefined && Array.isArray(data.topics)) {
            data.topics.forEach((item: any) => result.topics.push(Topic.fromResponse(item)));
        }

        if (data.euCivilianTrainingAreas != undefined && Array.isArray(data.euCivilianTrainingAreas)) {
            data.euCivilianTrainingAreas.forEach((item: any) => result.euCivilianTrainingAreas.push(CivilianTrainingArea.fromResponse(item)));
        }

        if (data.militaryDisciplines != undefined && Array.isArray(data.militaryDisciplines)) {
            data.militaryDisciplines.forEach((item: any) => result.militaryDisciplines.push(MilitaryDiscipline.fromResponse(item)));
        }

        if (data.otherTrainingInstitutions != undefined && Array.isArray(data.otherTrainingInstitutions)) {
            data.otherTrainingInstitutions.forEach((item: any) => result.otherTrainingInstitutions.push(TrainingInstitutionLite.fromResponse(item)));
        }

        if (data.trainingAudiences != undefined && Array.isArray(data.trainingAudiences)) {
            data.trainingAudiences.forEach((item: any) => result.trainingAudiences.push(TrainingAudience[item as keyof typeof TrainingAudience]));
        }

        return result;

    }
    
}